var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',[_c('v-progress-linear',{style:({ width: _vm.width }),attrs:{"indeterminate":"","color":_vm.color}}),_c('p',[_vm._v(_vm._s(_vm.label))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }